class NavigationInstanceResolver {
    static Instantiate(NavigationInstance) {
        if (!this._NavigationInstance) {
            this._NavigationInstance = NavigationInstance;
        }
        return this._NavigationInstance;
    }
    static get Instance() {
        return this._NavigationInstance;
    }
}

export { NavigationInstanceResolver as N };

//# sourceMappingURL=navigationInstanceResolver-9f4ebf1c.js.map